/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** AuditLogGetAllPaginationResponse */
export interface AuditLogGetAllPaginationResponse {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: AuditLogResponse[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/** AuditLogResponse */
export interface AuditLogResponse {
  /** Userid */
  userId?: number | null;
  /** Useremail */
  userEmail?: string | null;
  /** Actorrole */
  actorRole: 'adm' | 'cgv' | 'clt' | 'doc' | 'sys';
  /** Method */
  method: 'GET' | 'HEAD' | 'POST' | 'PUT' | 'PATCH' | 'DELETE' | 'OPTIONS';
  /** Routepath */
  routePath: string;
  /** Requestpath */
  requestPath: string;
  /** Querystring */
  queryString?: string | null;
  /** Statuscode */
  statusCode: number;
  /** Durationms */
  durationMs: number;
  /** Ipaddr */
  ipAddr?: string | null;
  /** Useragent */
  userAgent?: string | null;
  /** Userrouteauditid */
  userRouteAuditId: number;
  /**
   * Createdat
   * @format date-time
   */
  createdAt: string;
}

/** AuditTrailGetAllPaginationResponse */
export interface AuditTrailGetAllPaginationResponse {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: AuditTrailResponse[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/** AuditTrailResponse */
export interface AuditTrailResponse {
  /**
   * Changesetid
   * @format uuid
   */
  changeSetId: string;
  /** Actiontype */
  actionType: 'create' | 'update' | 'delete';
  /** Entityfullname */
  entityFullName: string;
  /** Entityid */
  entityId: string;
  /** Entityshortname */
  entityShortName: string;
  /** Entrytype */
  entryType: 'entity' | 'property';
  /** Metadata */
  metadata?: Record<string, any> | null;
  /** Ipaddress */
  ipAddress?: string | null;
  /** Newvalue */
  newValue?: null;
  /** Oldvalue */
  oldValue?: null;
  /** Propertyname */
  propertyName?: string | null;
  /**
   * Createdat
   * @format date-time
   */
  createdAt: string;
  /** Userid */
  userId?: number | null;
  /** Actoridentifier */
  actorIdentifier?: string | null;
  /** Audittrailid */
  auditTrailId: number;
}

/** Body_createClickUpTicket */
export interface BodyCreateClickUpTicket {
  /**
   * Title
   * Ticket title
   */
  title: string;
  /**
   * Description
   * Ticket description
   */
  description?: string | null;
  /**
   * Priority
   * 1=Urgent, 2=High, 3=Normal, 4=Low
   * @default 3
   */
  priority?: number | null;
  /** Status Value */
  status_value?: string | null;
  /**
   * Due Date
   * Due date
   */
  due_date?: string | null;
  /**
   * Assignees
   * Comma-separated assignee IDs
   */
  assignees?: string | null;
  /**
   * Custom Fields
   * JSON string of custom fields. Schema: {"id": <id>, "value": <str|float|int>}
   */
  custom_fields?: string | null;
  /**
   * Files
   * Attachment files
   */
  files?: File[] | null;
}

/** DailyRouteUsage */
export interface DailyRouteUsage {
  /**
   * Date
   * @format date
   */
  date: string;
  /** Provider */
  provider: 'mapbox' | 'google';
  /** Requestcount */
  requestCount: number;
}

/** DailyVisitCounts */
export interface DailyVisitCounts {
  /**
   * Total
   * @default 0
   */
  total?: number;
  /**
   * Scheduled
   * @default 0
   */
  scheduled?: number;
  /**
   * Inprogress
   * @default 0
   */
  inProgress?: number;
  /**
   * Completed
   * @default 0
   */
  completed?: number;
  /**
   * Cancelled
   * @default 0
   */
  cancelled?: number;
  /**
   * Date
   * @format date
   */
  date: string;
}

/**
 * DeploymentBranding
 * Per-organization branding keys.
 *
 * Values are identifiers, not URLs or asset paths: the client owns the assets and
 * maps the key to one it has bundled, falling back to its default for an unknown
 * key. That keeps an unrecognised value from breaking an older app build.
 */
export interface DeploymentBranding {
  /**
   * Hometablogo
   * Identifier of the mark shown on the mobile Home tab (e.g. 'alivio').
   */
  homeTabLogo: string;
}

/**
 * DeploymentConfigResponse
 * Everything a client needs to know about how this deployment is configured.
 */
export interface DeploymentConfigResponse {
  /**
   * Realm
   * Keycloak realm / organization this deployment serves.
   */
  realm: string;
  /** Feature switches. Each maps 1:1 to an ``ENABLE_*`` deployment setting. */
  features: DeploymentFeatures;
  /**
   * Per-organization branding keys.
   *
   * Values are identifiers, not URLs or asset paths: the client owns the assets and
   * maps the key to one it has bundled, falling back to its default for an unknown
   * key. That keeps an unrecognised value from breaking an older app build.
   */
  branding: DeploymentBranding;
  /**
   * Backendversion
   * Running backend release: the git tag (1.15.2), or develop-<sha> on dev; null = unknown.
   */
  backendVersion?: string | null;
}

/**
 * DeploymentFeatures
 * Feature switches. Each maps 1:1 to an ``ENABLE_*`` deployment setting.
 */
export interface DeploymentFeatures {
  /**
   * Caregivercashregister
   * Caregivers hold cash collected on visits and hand it back later. Drives the cash chip on Home and the caregiver cash screen.
   */
  caregiverCashRegister: boolean;
  /**
   * Notificationrejection
   * Caregivers may reject an assignment / reschedule notification. When false, clients hide every reject entry point.
   */
  notificationRejection: boolean;
}

/** DeploymentVersion */
export interface DeploymentVersion {
  /** Releaseversion */
  releaseVersion?: string | null;
  /** Releasehomecareversion */
  releaseHomecareVersion?: string | null;
  /** Backendversion */
  backendVersion?: string | null;
  /** Homecareversion */
  homecareVersion: string;
  /**
   * Startedat
   * @format date-time
   */
  startedAt: string;
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/** MonthlyRouteUsage */
export interface MonthlyRouteUsage {
  /** Month */
  month: string;
  /** Provider */
  provider: 'mapbox' | 'google';
  /** Requestcount */
  requestCount: number;
}

/** MonthlyVisitCounts */
export interface MonthlyVisitCounts {
  /**
   * Total
   * @default 0
   */
  total?: number;
  /**
   * Scheduled
   * @default 0
   */
  scheduled?: number;
  /**
   * Inprogress
   * @default 0
   */
  inProgress?: number;
  /**
   * Completed
   * @default 0
   */
  completed?: number;
  /**
   * Cancelled
   * @default 0
   */
  cancelled?: number;
  /** Month */
  month: string;
}

/** OnlineUserResponse */
export interface OnlineUserResponse {
  /**
   * Email
   * @format email
   */
  email: string;
  /** Firstname */
  firstName?: string | null;
  /** Lastname */
  lastName?: string | null;
  /** Avatarurl */
  avatarUrl?: string | null;
  /**
   * Enabled
   * @default false
   */
  enabled?: boolean | null;
  /**
   * Timezone
   * @default "Europe/Athens"
   */
  timezone?: string;
  /**
   * Locale
   * @default "en"
   */
  locale?: string;
  /** Userid */
  userId: number;
  /**
   * Createdat
   * @format date-time
   */
  createdAt: string;
  /** Updatedat */
  updatedAt: string | null;
  /**
   * Emailverified
   * @default false
   */
  emailVerified?: boolean | null;
  /** Roles */
  roles: RoleResponse[];
  /** Requiredactions */
  requiredActions?: ('UPDATE_PASSWORD' | 'VERIFY_EMAIL')[] | null;
  /**
   * Hasaccount
   * @default true
   */
  hasAccount?: boolean;
  /**
   * Lastactivityat
   * @format date-time
   */
  lastActivityAt: string;
  /** Lastactivitymethod */
  lastActivityMethod: 'GET' | 'HEAD' | 'POST' | 'PUT' | 'PATCH' | 'DELETE' | 'OPTIONS';
  /** Lastactivityroutepath */
  lastActivityRoutePath: string;
  /** Lastactivityrequestpath */
  lastActivityRequestPath: string;
}

/** OnlineUsersGetAllPaginationResponse */
export interface OnlineUsersGetAllPaginationResponse {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: OnlineUserResponse[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/** RoleResponse */
export interface RoleResponse {
  /** Name */
  name: string;
  /** Code */
  code: string;
  /** Description */
  description?: string | null;
  /** Roleid */
  roleId: number;
}

/** RouteUsageCaps */
export interface RouteUsageCaps {
  /** Daily */
  daily: number;
  /** Monthly */
  monthly: number;
}

/** RouteUsageCurrent */
export interface RouteUsageCurrent {
  /** Provider */
  provider: 'mapbox' | 'google';
  /** Today */
  today: number;
  /** Month */
  month: number;
}

/** RouteUsageResponse */
export interface RouteUsageResponse {
  /**
   * Fromdate
   * @format date
   */
  fromDate: string;
  /**
   * Todate
   * @format date
   */
  toDate: string;
  /**
   * Daybasis
   * @default "UTC"
   */
  dayBasis?: 'UTC';
  /** Daily */
  daily: DailyRouteUsage[];
  /** Monthly */
  monthly: MonthlyRouteUsage[];
  caps: RouteUsageCaps;
  /** Current */
  current: RouteUsageCurrent[];
}

/** UserCreateReq */
export interface UserCreateReq {
  /**
   * Email
   * @format email
   */
  email: string;
  /** Firstname */
  firstName?: string | null;
  /** Lastname */
  lastName?: string | null;
  /** Avatarurl */
  avatarUrl?: string | null;
  /**
   * Enabled
   * @default false
   */
  enabled?: boolean | null;
  /**
   * Timezone
   * @default "Europe/Athens"
   */
  timezone?: string;
  /**
   * Locale
   * @default "en"
   */
  locale?: string;
  /** Caregiverid */
  caregiverId?: number | null;
  /** Clientid */
  clientId?: number | null;
  /** Doctorid */
  doctorId?: number | null;
  /** Roles */
  roles: ('adm' | 'cgv' | 'clt' | 'doc' | 'ofa')[];
}

/** UserListViewCreateReq */
export interface UserListViewCreateReq {
  /** Viewname */
  viewName: string;
  /** Tablename */
  tableName: string;
  /** Viewconfig */
  viewConfig: Record<string, any>;
  /**
   * Isdefault
   * @default false
   */
  isDefault?: boolean;
}

/** UserListViewResponse */
export interface UserListViewResponse {
  /** Viewname */
  viewName: string;
  /** Tablename */
  tableName: string;
  /** Viewconfig */
  viewConfig: Record<string, any>;
  /**
   * Isdefault
   * @default false
   */
  isDefault?: boolean;
  /** Userlistviewid */
  userListViewId: number;
  /**
   * Createdat
   * @format date-time
   */
  createdAt: string;
  /**
   * Updatedat
   * @format date-time
   */
  updatedAt: string;
}

/** UserListViewUpdateReq */
export interface UserListViewUpdateReq {
  /** Viewname */
  viewName?: string | null;
  /** Tablename */
  tableName?: string | null;
  /** Viewconfig */
  viewConfig?: Record<string, any> | null;
  /** Isdefault */
  isDefault?: boolean | null;
}

/** UserResponse */
export interface UserResponse {
  /**
   * Email
   * @format email
   */
  email: string;
  /** Firstname */
  firstName?: string | null;
  /** Lastname */
  lastName?: string | null;
  /** Avatarurl */
  avatarUrl?: string | null;
  /**
   * Enabled
   * @default false
   */
  enabled?: boolean | null;
  /**
   * Timezone
   * @default "Europe/Athens"
   */
  timezone?: string;
  /**
   * Locale
   * @default "en"
   */
  locale?: string;
  /** Userid */
  userId: number;
  /**
   * Createdat
   * @format date-time
   */
  createdAt: string;
  /** Updatedat */
  updatedAt: string | null;
  /**
   * Emailverified
   * @default false
   */
  emailVerified?: boolean | null;
  /** Roles */
  roles: RoleResponse[];
  /** Requiredactions */
  requiredActions?: ('UPDATE_PASSWORD' | 'VERIFY_EMAIL')[] | null;
  /**
   * Hasaccount
   * @default true
   */
  hasAccount?: boolean;
}

/** UserUpdateReq */
export interface UserUpdateReq {
  /** Email */
  email?: string | null;
  /** Firstname */
  firstName?: string | null;
  /** Lastname */
  lastName?: string | null;
  /** Avatarurl */
  avatarUrl?: string | null;
  /** Enabled */
  enabled?: boolean | null;
  /** Timezone */
  timezone?: string | null;
  /** Locale */
  locale?: string | null;
  /** Requiredactions */
  requiredActions?: ('UPDATE_PASSWORD' | 'VERIFY_EMAIL')[] | null;
  /** Roles */
  roles?: ('adm' | 'cgv' | 'clt' | 'doc' | 'ofa')[] | null;
  /** Caregiverid */
  caregiverId?: number | null;
  /** Clientid */
  clientId?: number | null;
  /** Doctorid */
  doctorId?: number | null;
}

/** UsersGetAllPaginationResponse */
export interface UsersGetAllPaginationResponse {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: UserResponse[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
}

/** VersionHistoryResponse */
export interface VersionHistoryResponse {
  /** Data */
  data: DeploymentVersion[];
}

/**
 * VersionsResponse
 * Which backend versions this deployment runs.
 */
export interface VersionsResponse {
  /**
   * Backendversion
   * Running backend release: the git tag (1.15.2), or develop-<sha> on dev; null = unknown.
   */
  backendVersion?: string | null;
  /**
   * Homecareversion
   * Version of the shared homecare module (its __init__.py).
   */
  homecareVersion: string;
  /**
   * Releaseversion
   * Release (git tag) this build is based on. On a tag build it is that tag, including a pre-release tag (e.g. 1.12.0-RC). On a branch build it is the highest X.Y.Z tag that existed at build time, which may not be an ancestor of the build (e.g. a hotfix tagged on main while this build is from develop). null = unknown.
   */
  releaseVersion?: string | null;
  /**
   * Releasehomecareversion
   * Homecare module version inside that release tag; compare with homecareVersion to see how far this build is from it. null = unknown.
   */
  releaseHomecareVersion?: string | null;
}

/** VisitCountsResponse */
export interface VisitCountsResponse {
  /**
   * Fromdate
   * @format date
   */
  fromDate: string;
  /**
   * Todate
   * @format date
   */
  toDate: string;
  /** Tz */
  tz: string;
  /** Daily */
  daily: DailyVisitCounts[];
  /** Monthly */
  monthly: MonthlyVisitCounts[];
  totals: VisitStatusCounts;
}

/** VisitStatusCounts */
export interface VisitStatusCounts {
  /**
   * Total
   * @default 0
   */
  total?: number;
  /**
   * Scheduled
   * @default 0
   */
  scheduled?: number;
  /**
   * Inprogress
   * @default 0
   */
  inProgress?: number;
  /**
   * Completed
   * @default 0
   */
  completed?: number;
  /**
   * Cancelled
   * @default 0
   */
  cancelled?: number;
}

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from 'axios';
import axios from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  JsonApi = 'application/vnd.api+json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || '/api/v1/users-api/',
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { 'Content-Type': type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title users
 * @version 1.0.0
 * @baseUrl /api/v1/users-api/
 *
 *
 * Microservice for managing home care users.
 *
 * ## Features
 * * Create, read, update, and delete user records
 * * Secure endpoints with authentication and authorization
 *
 * ## Authentication
 * All endpoints require authentication using JWT tokens.
 * Admin endpoints require additional admin permissions.
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  users = {
    /**
     * No description
     *
     * @tags System
     * @name GetSystemVisitCounts
     * @summary Visits per day and month
     * @request GET:/users/system/visit-counts
     * @secure
     */
    getSystemVisitCounts: (
      query: {
        /**
         * From
         * @format date
         */
        from: string;
        /**
         * To
         * @format date
         */
        to: string;
        /**
         * Tz
         * IANA time zone the days are counted in
         */
        tz: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<VisitCountsResponse, HTTPValidationError>({
        path: `/users/system/visit-counts`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags System
     * @name GetSystemRouteUsage
     * @summary Routing API requests per UTC day and month
     * @request GET:/users/system/route-usage
     * @secure
     */
    getSystemRouteUsage: (
      query: {
        /**
         * From
         * @format date
         */
        from: string;
        /**
         * To
         * @format date
         */
        to: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<RouteUsageResponse, HTTPValidationError>({
        path: `/users/system/route-usage`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags System
     * @name GetSystemVersionHistory
     * @summary Backend versions this deployment has run, newest first
     * @request GET:/users/system/version-history
     * @secure
     */
    getSystemVersionHistory: (
      query?: {
        /**
         * Limit
         * @min 1
         * @max 200
         * @default 50
         */
        limit?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<VersionHistoryResponse, HTTPValidationError>({
        path: `/users/system/version-history`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve a list of all user roles
     *
     * @tags Roles
     * @name ListUserRoles
     * @summary Get all roles
     * @request GET:/users/roles
     * @secure
     */
    listUserRoles: (params: RequestParams = {}) =>
      this.request<RoleResponse[], void>({
        path: `/users/roles`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve a list of users with pagination support
     *
     * @tags Users
     * @name ListUsers
     * @summary Get users (list or search)
     * @request GET:/users
     * @secure
     */
    listUsers: (
      query?: {
        /**
         * Offset
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * @default 100
         */
        limit?: number;
        /**
         * Query
         * Free text query; if not given return all; if given (>3 chars) searches
         */
        query?: string | null;
        /**
         * Sort
         * JSON:API sorting, e.g. 'last_name,-created_at'. Prefix with '-' for DESC.
         */
        sort?: string | null;
        /**
         * Roles
         * Filter by role codes (e.g., 'adm', 'cgv', 'clt')
         */
        roles?: ('adm' | 'cgv' | 'clt' | 'doc' | 'ofa')[] | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<UsersGetAllPaginationResponse, HTTPValidationError | void>({
        path: `/users`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a new user
     *
     * @tags Users
     * @name CreateUser
     * @summary Create new user
     * @request POST:/users
     * @secure
     */
    createUser: (data: UserCreateReq, params: RequestParams = {}) =>
      this.request<UserResponse, void | HTTPValidationError>({
        path: `/users`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve users whose latest audited request activity is within the given threshold window.
     *
     * @tags Users
     * @name ListOnlineUsers
     * @summary Get online users
     * @request GET:/users/online
     * @secure
     */
    listOnlineUsers: (
      query?: {
        /**
         * Threshold Minutes
         * A user is considered online when their latest audited request happened within this many minutes.
         * @min 1
         * @max 1440
         * @default 5
         */
        threshold_minutes?: number;
        /**
         * Offset
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<OnlineUsersGetAllPaginationResponse, HTTPValidationError | void>({
        path: `/users/online`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve a specific user by their ID
     *
     * @tags Users
     * @name GetUserById
     * @summary Get user by ID
     * @request GET:/users/{user_id}
     * @secure
     */
    getUserById: (userId: number, params: RequestParams = {}) =>
      this.request<UserResponse, void | HTTPValidationError>({
        path: `/users/${userId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update an existing user's information
     *
     * @tags Users
     * @name UpdateUser
     * @summary Update user
     * @request PUT:/users/{user_id}
     * @secure
     */
    updateUser: (userId: number, data: UserUpdateReq, params: RequestParams = {}) =>
      this.request<UserResponse, void | HTTPValidationError>({
        path: `/users/${userId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a user by ID
     *
     * @tags Users
     * @name DeleteUser
     * @summary Delete user
     * @request DELETE:/users/{user_id}
     * @secure
     */
    deleteUser: (userId: number, params: RequestParams = {}) =>
      this.request<void, void | HTTPValidationError>({
        path: `/users/${userId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Resend the Keycloak e-mail verification action to a user
     *
     * @tags Users
     * @name ResendVerification
     * @summary Resend verification email
     * @request POST:/users/{user_id}/resend-verification
     * @secure
     */
    resendVerification: (userId: number, params: RequestParams = {}) =>
      this.request<void, void | HTTPValidationError>({
        path: `/users/${userId}/resend-verification`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * @description Create a Keycloak account for a user that has none (e.g. an orphaned user whose stored kc_id no longer exists in the realm).
     *
     * @tags Users
     * @name ProvisionAccount
     * @summary Provision identity-provider account
     * @request POST:/users/{user_id}/provision-account
     * @secure
     */
    provisionAccount: (userId: number, params: RequestParams = {}) =>
      this.request<UserResponse, void | HTTPValidationError>({
        path: `/users/${userId}/provision-account`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve users based on their assigned role
     *
     * @tags Users
     * @name GetUsersByRole
     * @summary Get users by role
     * @request GET:/users/role/{role}
     * @secure
     */
    getUsersByRole: (role: number, params: RequestParams = {}) =>
      this.request<number[], HTTPValidationError | void>({
        path: `/users/role/${role}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve all personalized list views for the authenticated user
     *
     * @tags UserListViews
     * @name GetUserListViews
     * @summary Get all list views for a user
     * @request GET:/users/list-views
     * @secure
     */
    getUserListViews: (
      query?: {
        /** Table Name */
        table_name?: string | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<UserListViewResponse[], void | HTTPValidationError>({
        path: `/users/list-views`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a new personalized list view for the user
     *
     * @tags UserListViews
     * @name CreateUserListView
     * @summary Create a new list view
     * @request POST:/users/list-views
     * @secure
     */
    createUserListView: (data: UserListViewCreateReq, params: RequestParams = {}) =>
      this.request<UserListViewResponse, void | HTTPValidationError>({
        path: `/users/list-views`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve a specific list view by ID
     *
     * @tags UserListViews
     * @name GetUserListViewById
     * @summary Get a specific list view
     * @request GET:/users/list-views/{user_list_view_id}
     * @secure
     */
    getUserListViewById: (userListViewId: number, params: RequestParams = {}) =>
      this.request<UserListViewResponse, void | HTTPValidationError>({
        path: `/users/list-views/${userListViewId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update an existing list view
     *
     * @tags UserListViews
     * @name UpdateUserListView
     * @summary Update a list view
     * @request PATCH:/users/list-views/{user_list_view_id}
     * @secure
     */
    updateUserListView: (userListViewId: number, data: UserListViewUpdateReq, params: RequestParams = {}) =>
      this.request<UserListViewResponse, void | HTTPValidationError>({
        path: `/users/list-views/${userListViewId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete an existing list view
     *
     * @tags UserListViews
     * @name DeleteUserListView
     * @summary Delete a list view
     * @request DELETE:/users/list-views/{user_list_view_id}
     * @secure
     */
    deleteUserListView: (userListViewId: number, params: RequestParams = {}) =>
      this.request<void, void | HTTPValidationError>({
        path: `/users/list-views/${userListViewId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Retrieve paginated audit trail records with optional filters.
     *
     * @tags AuditTrail
     * @name ListAuditTrail
     * @summary Get audit trail entries
     * @request GET:/users/audit-trail
     * @secure
     */
    listAuditTrail: (
      query?: {
        /**
         * Offset
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * @default 100
         */
        limit?: number;
        /**
         * Query
         * Search by user name, entity, property, route context, or serialized values
         */
        query?: string | null;
        /**
         * Action Type
         * Filter by action type: create, update, delete
         */
        action_type?: string | null;
        /**
         * Entry Type
         * Filter by entry type: entity or property
         */
        entry_type?: string | null;
        /**
         * Entity Short Name
         * Filter by exact entity short name
         */
        entity_short_name?: string | null;
        /**
         * Entity Id
         * Filter by exact entity identifier
         */
        entity_id?: string | null;
        /**
         * Actor Identifier
         * Filter by actor identifier, usually email or username
         */
        actor_identifier?: string | null;
        /**
         * From Date
         * Filter trail entries on or after this ISO datetime
         */
        from_date?: string | null;
        /**
         * To Date
         * Filter trail entries on or before this ISO datetime
         */
        to_date?: string | null;
        /**
         * Sort
         * JSON:API sorting, e.g. '-created_at,entity_short_name'. Allowed fields: created_at,action_type,entry_type,entity_full_name,entity_short_name,entity_id,property_name,user_id,actor_identifier
         * @default "-created_at"
         */
        sort?: string | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<AuditTrailGetAllPaginationResponse, void>({
        path: `/users/audit-trail`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve paginated user route audit records with optional filters.
     *
     * @tags UserAudits
     * @name ListUserRouteAudits
     * @summary Get user route audits
     * @request GET:/users/audits
     * @secure
     */
    listUserRouteAudits: (
      query?: {
        /**
         * Offset
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * @default 100
         */
        limit?: number;
        /**
         * Query
         * Search by user email, route path, request path, IP address, or user agent
         */
        query?: string | null;
        /**
         * Method
         * Filter by HTTP method
         */
        method?: 'GET' | 'HEAD' | 'POST' | 'PUT' | 'PATCH' | 'DELETE' | 'OPTIONS' | null;
        /**
         * Status Code
         * Filter by exact HTTP status code
         */
        status_code?: number | null;
        /**
         * User Id
         * Filter by exact user ID
         */
        user_id?: number | null;
        /**
         * From Date
         * Filter audits created on or after this ISO datetime
         */
        from_date?: string | null;
        /**
         * To Date
         * Filter audits created on or before this ISO datetime
         */
        to_date?: string | null;
        /**
         * Sort
         * JSON:API sorting, e.g. '-created_at,status_code'. Allowed fields: created_at,status_code,user_id,user_email,actor_role,method,route_path,request_path,duration_ms
         * @default "-created_at"
         */
        sort?: string | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<AuditLogGetAllPaginationResponse, void>({
        path: `/users/audits`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  health = {
    /**
     * @description Returns the health status and version of the service
     *
     * @tags Health
     * @name GetUserServiceHealth
     * @summary Health check endpoint
     * @request GET:/health
     * @secure
     */
    getUserServiceHealth: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/health`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  tickets = {
    /**
     * @description Creates a new ClickUp task with support for attachments, custom fields, status updates, and due dates.
     *
     * @tags Tickets
     * @name CreateClickUpTicket
     * @summary Create a ClickUp ticket with optional fields
     * @request POST:/tickets
     * @secure
     */
    createClickUpTicket: (data: BodyCreateClickUpTicket, params: RequestParams = {}) =>
      this.request<any, void | HTTPValidationError>({
        path: `/tickets`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),
  };
  deployment = {
    /**
     * @description Returns the per-organization configuration clients need in order to adapt their UI: which optional features this deployment runs, and which brand assets to use. Values come from the deployment's environment, so changing one is a redeploy of this organization — not an app release. Clients should treat every field as optional and fall back to their own defaults, so an older build keeps working against a newer backend.
     *
     * @tags Deployment
     * @name GetDeploymentConfig
     * @summary Configuration of this deployment (feature switches + branding)
     * @request GET:/deployment/config
     * @secure
     */
    getDeploymentConfig: (params: RequestParams = {}) =>
      this.request<DeploymentConfigResponse, void>({
        path: `/deployment/config`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  versions = {
    /**
     * @description Public, for monitoring without a login. `backendVersion` is the running build and `homecareVersion` its homecare module version; `releaseVersion` is the release tag this build is based on and `releaseHomecareVersion` the homecare version in that tag, so `homecareVersion` shows how far this build is from the release. `null` = not set.
     *
     * @tags Deployment
     * @name GetVersions
     * @summary Backend versions this deployment runs
     * @request GET:/versions
     * @secure
     */
    getVersions: (params: RequestParams = {}) =>
      this.request<VersionsResponse, any>({
        path: `/versions`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
}
